__turbopack_context__.v({
  "columns": "styles-module__WYDp1a__columns",
  "cta": "styles-module__WYDp1a__cta",
  "ctaContentWrapper": "styles-module__WYDp1a__ctaContentWrapper",
  "displayImage": "styles-module__WYDp1a__displayImage",
  "introContainer": "styles-module__WYDp1a__introContainer",
  "logoContainer": "styles-module__WYDp1a__logoContainer",
  "pinkBackground": "styles-module__WYDp1a__pinkBackground",
  "section": "styles-module__WYDp1a__section",
  "sectionTitle": "styles-module__WYDp1a__sectionTitle",
});
